import { apiClient } from '../api/client'
import { API_ENDPOINTS } from '../api/endpoints'
import { generateDeviceId, collectDeviceInfo } from './deviceRegistration'

export interface ClientRegistrationRequest {
  clientId: string
  deviceName: string
  publicIpAddress: string
  listeningPort: number
  secretKey?: string
  additionalInfo?: string
}

export interface ClientRegistrationResponse {
  success: boolean
  message: string
  serverTime: string
  pollingIntervalSeconds: number
}

/**
 * اكتشاف IP العام (محاولة بسيطة)
 */
async function discoverPublicIp(): Promise<string> {
  return 'unknown'
}

/**
 * تسجيل الجهاز في نظام الإشارات (Signal System)
 */
export async function registerClientInSignalSystem(
  listeningPort: number = 8080,
  secretKey?: string
): Promise<ClientRegistrationResponse | null> {
  try {
    const deviceInfo = collectDeviceInfo()
    const deviceId = generateDeviceId()
    
    // محاولة اكتشاف IP العام
    const publicIp = await discoverPublicIp()
    
    const registrationData: ClientRegistrationRequest = {
      clientId: deviceId,
      deviceName: deviceInfo.deviceName,
      publicIpAddress: publicIp,
      listeningPort: listeningPort,
      secretKey: secretKey,
      additionalInfo: JSON.stringify({
        deviceFingerprint: deviceInfo.deviceFingerprint,
        operatingSystem: deviceInfo.operatingSystem,
        browserInfo: deviceInfo.browserInfo,
        screenResolution: deviceInfo.screenResolution,
        timeZone: deviceInfo.timeZone,
        language: deviceInfo.language,
      }),
    }

    const response = await apiClient.post<ClientRegistrationResponse>(
      API_ENDPOINTS.signals.registerClient,
      registrationData
    )

    if (response.data.success) {
      // حفظ معلومات التسجيل
      localStorage.setItem('signalClientRegistered', 'true')
      localStorage.setItem('signalClientId', deviceId)
      localStorage.setItem('signalPollingInterval', response.data.pollingIntervalSeconds.toString())
      
      console.log('✅ Client registered in Signal System:', response.data.message)
    }

    return response.data
  } catch (error: any) {
    console.error('❌ Error registering client in Signal System:', error)
    // لا نرمي خطأ حتى لا يعطل التطبيق
    return null
  }
}

/**
 * التحقق من تسجيل الجهاز في نظام الإشارات
 */
export function isClientRegisteredInSignalSystem(): boolean {
  return localStorage.getItem('signalClientRegistered') === 'true'
}

/**
 * الحصول على Client ID المحفوظ
 */
export function getSignalClientId(): string | null {
  return localStorage.getItem('signalClientId')
}

/**
 * الحصول على Polling Interval
 */
export function getSignalPollingInterval(): number {
  const interval = localStorage.getItem('signalPollingInterval')
  return interval ? parseInt(interval, 10) : 15
}

